// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3bpoM","header":"PatientBlock_header__3lw8b","label":"PatientBlock_label__1s8E7","option":"PatientBlock_option__3P0ek"};